import type { ISEOProps } from "../types/core";

export const SettingsPageSEO: ISEOProps = {
  title: "Settings - Sugar Cribs",
  description:
    "Manage your Sugar Cribs account settings, privacy preferences, and notification options.",
};
